/* eslint react/no-danger: 0 */
import React, { Component, useEffect } from 'react';
import Observer from 'react-intersection-observer';
//import content from '../../content';
import chevronLeft from '../../images/chevron-left.svg';
import chevronLeftWhite from '../../images/chevron-left--white.svg';
import chevronRight from '../../images/chevron-right.svg';
import chevronRightWhite from '../../images/chevron-right--white.svg';
import { GAfireEvent } from '../Tracking';
import 'react-app-polyfill/ie11';
import { isEs } from "../../libs/lang";

import { fireTag } from '../../libs/analytics';

const content = isEs() ? require('../../contentES').default : require('../../content').default;


const StatItem = ({stat, index}) => (
	<div
		className="tile"
		tabIndex="-1"
	>
		<div className={`stat-image ${stat.attrib.toLowerCase().replace(/ /g, '-')}`} aria-label={stat.imgAlt} alt={stat.imgAlt} role="img"/>
		<div className="stat-item">
			<p className="problem" dangerouslySetInnerHTML={{__html: stat.body}}/>
		</div>
	</div>
)

class Solutions extends Component {
	constructor(props) {
		super(props);

		// set our first quote to be the active quote on initial component load
		this.state = {
			activeQuote: 0
		};
	}

	goToQuote = (btnClicked) => {
		const curStat = this.state.activeQuote;

		if (btnClicked === 'quote-next') {
			if (curStat < content.housing.solutions.tiles.length - 1) {
				this.setState({
					activeQuote: curStat + 1
				}, () => {
					document.querySelector('#housing-solutions .stat-tiles .tile.active').focus();
				});
				//GAfireEvent('G13');
			}
		}
		else {
			// clicked prev button
			if (curStat > 0) {
				this.setState({
					activeQuote: curStat - 1
				}, () => {
					document.querySelector('#housing-solutions .stat-tiles .tile.active').focus();
				});
				//GAfireEvent('G12');
			}
		}
	}

	componentDidMount() {

		let scrollSolutions = false;


		window.addEventListener('scroll',()=>{
			if(!window.location.href.includes('/housing/') && scrollSolutions && document.querySelector('#housing-solutions').getBoundingClientRect().top <= document.querySelector('nav').getBoundingClientRect().height){
				scrollSolutions = true;
				fireTag('S1');
			}
		});

		document.getElementById("stat-link-1").addEventListener('click', () => {
			fireTag("C1")
		})
		
	}

	componentDidUpdate() {
	}

	render() {
		const curStat = this.state.activeQuote;

		return (
			<>
				<Observer
					tag='section'
					id="housing-solutions"
					threshold={0.50}
					triggerOnce
					onChange={inView => {

					}}
				>
					<h2 tabIndex="-1" dangerouslySetInnerHTML={{__html: content.housing.solutions.headline}}/>
					<div className="stat-tiles">
						{
							content.housing.solutions.tiles.map((stat, index) => (
								<StatItem
									/* eslint-disable-next-line react/no-array-index-key */
									key={index}
									stat={stat}
									index={index}
									curStat={curStat}
									goToQuote={this.goToQuote}
								/>
							))
						}
					</div>

				</Observer>
			</>
		);
	}
}

export default Solutions;
